module.exports = __webpack_public_path__ + "static/media/korrekturForslag.17245805.png";